import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { API } from "../lib/site";

const POLL_MS = 10 * 60 * 1000;
const BUILD_KEY = "ce-build";
const RELOAD_KEY = "ce-reloaded-for";

const clearAppCaches = async () => {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    /* cache storage unavailable */
  }
};

export const VersionWatcher = () => {
  const busy = useRef(false);

  useEffect(() => {
    let timer;

    const applyNewVersion = async (build) => {
      if (busy.current) return;
      busy.current = true;
      localStorage.setItem(RELOAD_KEY, build);
      localStorage.setItem(BUILD_KEY, build);
      await clearAppCaches();
      toast.info("A fresh Cozy Ember build just landed — updating…");
      setTimeout(() => window.location.reload(), 1200);
    };

    const check = async () => {
      try {
        const res = await fetch(`${API}/version?ts=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const { build } = await res.json();
        if (!build) return;
        const stored = localStorage.getItem(BUILD_KEY);
        if (stored === null) {
          localStorage.setItem(BUILD_KEY, build);
          return;
        }
        if (build !== stored && localStorage.getItem(RELOAD_KEY) !== build) {
          await applyNewVersion(build);
        }
      } catch {
        /* offline or dev — ignore */
      }
    };

    check();
    timer = setInterval(check, POLL_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
};
